import utils from '../../../../modules/utils';
import API from '../../../api/api';
import doMetric from '../../../tracking/bigQueryMetricRecorder';
import Track from '../../../utils/tracking';

function isTokenReceived(status) {
  return status === 'HOSTED_PAYMENT_TOKEN_RECEIVED';
}

function isReturningFromHostedPage() {
  return window.start.selectedPaymentMethod === 'FRASERS_PLUS';
}

function isProblemWithService(status) {
  return (status === 'HOSTED_PAYMENT_AUTHENTICATION_FAILED'
    || status === 'HOSTED_PAYMENT_CURRENTLY_UNAVAILABLE');
}

function returnedFromHostedPage(queryParams = '') {
  const {paymentResult} = utils.fn.getURIParams(queryParams);
  
  try {
    doMetric('FrasersPlusProcessor', [{name: 'paymentResult', value: paymentResult}], [], 'impression');
  } catch (error) {
    Track.track(error);
  }
  
  // We only do not want the update call to happen if the paymentResult query param is DECLINED
  // This will help to prevent duplicate charges and Ghost orders if Frasers fail to append the
  // query param or they start sending different ones
  if (!paymentResult || paymentResult.toUpperCase() !== 'DECLINED') {
    return API.doAPIRequest('/v2/return-from-hosted/frasersPlus?status=SUCCESS');
  }
  
  return Promise.reject();
}

export default {
  isTokenReceived, isProblemWithService, isReturningFromHostedPage, returnedFromHostedPage,
};
